import {Input} from '@di-nxt/components';
import React from 'react';
import {t} from '../../../localization';
import {TeamMember} from '../../../services';
import {MemberFieldEditor} from '../Components';

type Props = {
  member: TeamMember;
  field: 'maxDailyHours' | 'minDailyHours';
  title: string;
  onEditModeChanged: (t: boolean) => void;
  disabled: boolean;
};

export const ShiftHoursEditor: React.FC<Props> = ({
  member,
  field,
  title,
  onEditModeChanged,
  disabled,
}) => {
  return (
    <MemberFieldEditor
      editKey={field}
      entity={member}
      title={title}
      onGetDisplayValue={(editState?: number) =>
        editState
          ? t('screens.member.fields.totalmontlyhours.format', {
              hours: member[field] ?? 0,
            })
          : '-'
      }
      disabled={disabled}
      onEditModeChanged={onEditModeChanged}>
      {(editState, setEditState) => (
        <Input
          inputWidth={45}
          value={editState?.toString()}
          onChange={(t: string) => setEditState(t ? parseInt(t) : 0)}
          rightText={t('screens.member.fields.totalmontlyhours.postfix')}
        />
      )}
    </MemberFieldEditor>
  );
};
